import { render, staticRenderFns } from "./phoneregister.vue?vue&type=template&id=4e00df4b&scoped=true"
import script from "./phoneregister.vue?vue&type=script&lang=js"
export * from "./phoneregister.vue?vue&type=script&lang=js"
import style0 from "./phoneregister.vue?vue&type=style&index=0&id=4e00df4b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e00df4b",
  null
  
)

export default component.exports